// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';

const initialState = {
  loading: false,
  error: null,
  statistics: null,
};

export const getPaymentABTestStatisticsAPIFn = createAsyncThunk(
  'adminDashboard/getPaymentABTestStatistics',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(endPoints.paymentABTestStatisticsURL);
      return data?.result ?? null;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data || 'Failed to load statistics'
      );
    }
  }
);

export const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {
    clearAdminDashboardStatistics: state => {
      state.statistics = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getPaymentABTestStatisticsAPIFn.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentABTestStatisticsAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
        state.error = null;
      })
      .addCase(getPaymentABTestStatisticsAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load statistics';
        state.statistics = null;
      });
  },
});

export const { clearAdminDashboardStatistics } = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
